<div class="error-container">
  <div class="error-content">
    <h1 class="error-title">Houve um erro</h1>
    <div class="error-image">
      <img src="assets/error-404.webp" alt="Erro 404" />
    </div>
    <div class="error-action">
      <button class="btn btn-primary" (click)="voltarParaInicio()">
        Voltar para a tela inicial
      </button>
    </div>
  </div>
</div>
